<template>
  <b-card class="rounded shadow-lg comment-card border-danger p-0 m-0 w-100 h-100">
    <b-row class="d-flex flex-row justify-content-center w-100 p-0 m-0">
      <b-col class="d-flex flex-column align-items-center py-1 px-0 w-100">
        <span class="set-font-12 text-center" v-if="comment.user">{{ `${comment.user.name} ${comment.user.last_name}` }}</span>
      </b-col>
    </b-row>
    <b-row class="d-flex flex-row justify-content-center w-100 p-0 m-0">
      <b-col class="d-flex flex-column align-items-center py-1 px-0 w-100">
        <span class="set-font-12 text-center p-2 bg-danger rounded text-light">کامنت مربوط به : {{ comment.commentable_type }}</span>
      </b-col>
    </b-row>
    <b-row class="w-100 p-0 m-0">
      <b-col class="d-flex flex-column align-items-center py-1 px-0 w-100">
        <p class="set-font-12" v-if="comment.body.length>90">{{ comment.body.slice(0, 100) }}</p>
        <p class="set-font-12" v-else>{{ comment.body }}</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="5" class="d-flex flex-column align-items-start py-1">
        <b-button pill class="bg-info" size="sm" @click="restoreComment(comment.id)">بازیابی</b-button>
      </b-col>
      <b-col cols="7" class="d-flex flex-column align-items-end py-1">
        <b-button pill class="bg-dark" size="sm" @click="forceDeleteComment(comment.id)">حذف از سطل زباله</b-button>
      </b-col>
    </b-row>
  </b-card>

</template>

<script>
export default {
  name: "TrashedComment",
  props:['comment'],
  methods:{
    restoreComment(commentId){
      if (confirm("آیا میخواهید کامنت دوباره ذخیره شود؟") === true) {
        this.$store.dispatch("Comment/restoreComment", commentId)
      }
    },
    forceDeleteComment(commentId){
      if (confirm("آیا از حذف کامنت اطمینان دارید؟") === true) {
        this.$store.dispatch("Comment/forceDelete", commentId)
      }
    }
  }
}
</script>

<style scoped>
.set-font-12{
  font-size: 12px;
}
</style>